export const customerFeedbackApiPaths = <const>{
    cannyIoBoards: '/App/GetCannyBoards',
};
